/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
class ServerStatusService extends __BaseService {
  static readonly ServerStatusGetStatusPath = '/server-status';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Return a status to the Unity WebGL build so we know the server is reachable. The return value has to match the value the
   * Unity client is expecting
   * @return Ok
   */
  ServerStatusGetStatusResponse(): __Observable<__StrictHttpResponse<{}>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/server-status`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<{}>;
      })
    );
  }
  /**
   * Return a status to the Unity WebGL build so we know the server is reachable. The return value has to match the value the
   * Unity client is expecting
   * @return Ok
   */
  ServerStatusGetStatus(): __Observable<{}> {
    return this.ServerStatusGetStatusResponse().pipe(
      __map(_r => _r.body as {})
    );
  }
}

module ServerStatusService {
}

export { ServerStatusService }
